module.exports = __webpack_public_path__ + "img/symphony_688_aubergine.ce82ebe5.jpg";